export const setTiposLeito = (state, payload) => {
    state.tiposLeito = payload;
}

export const setMapaTipoLeito = (state, payload) => {
    let unidades = Object.keys(payload)
    let dados = Object.values(payload)
    let resultado = new Array()

    unidades.forEach((i, index) => {
        let arrange = dados[index]
        let data =  {
                unidade: i,
                conteudo: arrange
            }
        
        resultado.push(data)
    })

    state.mapaTipoLeito = resultado;
}

export const setTipoLeitoFiltradoStatus = (state, payload) => {
    state.tipoLeitoFiltradoStatus = payload;
}

export const setQuantitativoLeitos = (state, payload) => {
    state.leitos = payload;
}